export enum DisplayMode {
  Light = 'Light',
  Dark = 'Dark',
}
